<template>
    <div>
        <van-icon name="arrow-left" class="icon" @click="icon"/>
        <van-tabs v-model="active">
            <van-tab title="已付款">
                <div class="list">
                      <div class="clear marleft3vw">
                        <div class="zhibo" v-for="orderlist in orderLists" v-bind:key="orderlist.cid" @click="infobtn(orderlist)">
                            <span class="kemu" style="display: none;"></span>
                            <span class="kemu_title">{{orderlist.name}}</span>
                            <p class="class_time">开课时间：{{orderlist.classtime_begin}}</p>
                            <div class="fff">
                                <div>
                                    <div class="img">
                                        <img src="@/assets/xioayalaoshi.png" alt="">
                                    </div> 
                                    <span class="teacher">{{orderlist.speaker_teacher}}</span>
                                </div>
                                <p class="money"><span>原价:¥{{orderlist.price}}</span>¥{{orderlist.sale_price}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </van-tab>
            <!-- <van-tab title="未付款">
                <div class="list">
                    <coursezhibo></coursezhibo>
                </div>
            </van-tab> -->
        </van-tabs>
    </div>
</template>

<script>
import Vue from 'vue';
import { Tab, Tabs } from 'vant';
import { Icon } from 'vant';

Vue.use(Icon)
Vue.use(Tab);
Vue.use(Tabs);
export default {
    components:{
       
    },
    data(){
            return {
                active: 0,
                userinfo:'',
                orderLists:'',
            };
    },
    mounted (){
        if (localStorage.getItem("userInfo")) {
                this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
        }
        this.getordercenter();
    },
    methods: {
        icon () {
            this.$router.go(-1)
        },
        infobtn(orderlist){
            this.$router.push({
                name:'zhiboxq',
                query:{
                    cid: orderlist.cid,
                    livetype : orderlist.livetype,
                    type: orderlist.type
                }
            })
        },
        getordercenter() {
            var params = {}
            params.page = 1
            params.pagenum = 3
            params.token = this.userInfo.token
            params.status = 1
            // console.log(params.token)
            this.$http.post ('/live/user/ordercenter',params)
                .then(orderRes => {
                    // console.log(orderRes)
                    if(orderRes.data.state === 0) {
                        this.orderLists = orderRes.data.result.list
                    }else if (orderRes.data.state===1){
                        Toast(orderRes.data.msg);
                    }
                })
                .catch(error => {
                    // console.log(error.response)
            })
        },


    }
}
</script>

<style scoped>
.icon{
    position: absolute;
    top: 15px;
    left: 16px;
    z-index: 2;
}
.van-tabs /deep/ .van-tabs__wrap {
  height: 36px;
  margin: 0 70px;
  background-color: #fff;
}
.van-tabs /deep/ .van-tabs__line {
  background-color: #3296fa;
  height: 2px;
}
.list{
    padding-top: 15px;
}
.zhibo{
    width: 90%;
    border-radius: 4px;
    /* background-color: rgba(187, 187, 187, 0.14); */
    box-shadow: #ddd 0px 0px 5px; 
    padding: 8px 8px 0;
    margin: 15px auto ;
}
.kemu{
    width: 40px;
    display: inline-block;
}
.kemu img{
    width: 100%;
    vertical-align: middle;
}
.kemu_title{
    line-height: 24px;
    margin-left: 3px;
    color: #2a2a2a;
    font-size: 16px;
    font-weight: 700;
    vertical-align: middle;
}
.class_time{
    line-height: 12px;
    font-size: 12px;
    color: #6e7578;
}
.fff{
    display: flex;
    justify-content: space-between;
}
.img{
    display: inline-block;
}
.img img{
     width: 28px;
    height: 28px;
    border-radius: 50%;
    vertical-align: middle;
}
.teacher{
    line-height: 28px;
    font-size: 14px;
    vertical-align: middle;
}
.money{
    color: rgba(244, 21, 33, 1);
    font-size: 18px;
    text-decoration: none;
    margin-top: 3px;
}
.money span{
    font-size: 12px;
    color: rgba(16, 16, 16, 0.36);
    text-decoration:line-through;
    margin-right: 3px;
}


</style>


// WEBPACK FOOTER //
// src/components/courseOrder.vue